/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-empty-object-type */
//import { useRef } from "react";
import { useAnimations, useGLTF /*, useAnimations*/ } from "@react-three/drei";
import * as THREE from "three";
import { forwardRef, useEffect } from "react";
export const tankAndFish = forwardRef(
  (props, ref: React.ForwardedRef<THREE.Group>) => {
    // const modelRef = useRef<THREE.Group | null>(null);
    const { scene, animations /*nodes, materials, animations*/ } = useGLTF(
      "/tank and fish.glb"
    ) as unknown as {
      scene: THREE.Group;
      nodes: { [key: string]: THREE.Mesh };
      materials: { [key: string]: THREE.Material };
      animations: any;
    };
    console.log("GLTF loadded:", { animations /*nodes, materials*/ });

    // @ts-expect-error some ref nonsense

    const { mixer, actions } = useAnimations(animations, ref);

    // Render the loaded scene.
    // The "scene" object contains all meshes, materials, and animations.
    useEffect(() => {
      if (ref && typeof ref !== "function" && ref.current) {
        // Traverse all meshes in the scene and enable shadows

        ref.current.traverse((node: THREE.Object3D) => {
          if (
            node instanceof THREE.Mesh &&
            !node.name.startsWith("tank") //&&
            //!node.name.startsWith("pebbles")
          ) {
            node.castShadow = false;
            node.receiveShadow = false;
          } else if (node instanceof THREE.Mesh) {
            node.castShadow = false;
            node.receiveShadow = false;
          }
        });
      }
    }, [ref]);

    return <primitive object={scene} ref={ref} {...props} />;
  }
);

useGLTF.preload("/tank and fish.glb");
